import Cabecera from './cabecera.jpg'

export default function App() {

  return (<>
    <div className="flex flex-col items-center h-full pt-2 bg-sky-50 min-h-screen">
      <div className="bg-white w-full max-w-[800px] "> {/* Ajusta el valor según necesites */}
        {/* Imagen */}
        <img
          src={Cabecera}
          className='w-full h-auto'
          alt="Imagen del evento"
        />


        {/* Título */}

        {/* Formulario */}
        <div className="flex flex-col bg-white items-center mt-5 sm:text-sm md:text-lg px-2">
          <div className="flex flex-col px-2 pb-5 items-center w-full">
            <p className="text-center">El Foro de la Construcción 2026<br />
              ha finalizado con éxito, agradecemos a todos<br />
              por acompañarnos nuevamente este año.<br />
              Los esperamos el próximo Foro.<br />
              Muchas gracias!<br />
            </p>
          </div>
        </div>
      </div>   </div>
  </>)
}
